type CustomErrors = Record<string, string | undefined>;

const omegaErrors: CustomErrors = {
    2002: "Неправильный логин или пароль",
    4001: "Метод обращения к этой функции не найден в текущей версии REST API сервера",
};

export function getCustomOmegaError(code: string): string | undefined {
    const customMessage = omegaErrors[code];
    return customMessage;
}

const axiosErrors: CustomErrors = {
    400: "Некорректный запрос",
    401: "Необходима авторизация",
    404: "Запрашиваемый ресурс не найден",
    500: "Внутренняя ошибка сервера",
    ERR_NETWORK: "Нет подключения к REST серверу",
    ECONNABORTED: "Превышено время ожидания, проверьте интернет соединение или доступность ресурса",
};

export function getCustomAxiosError(code: string): string | undefined {
    const customMessage = axiosErrors[code];
    return customMessage;
}
